import { slugifyTitle } from "@lms/backend/lib/video/slugify";

/**
 * The create-course rules, without zod, so the SPA can check a form before it
 * submits (CRS-009). `validations/course.ts` builds its schema from these same
 * constants, and a unit test holds the two to the same verdict on every sample.
 * Safe to import from browser bundles.
 */
export const COURSE_TITLE_MAX = 200;
export const COURSE_SLUG_MIN = 2;
export const COURSE_SLUG_MAX = 100;
export const COURSE_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export type CreateCourseFormErrors = {
  title?: "required" | "tooLong";
  slug?: "tooShort" | "tooLong" | "invalid";
};

/** A slug suggestion from the title — clipped to the limit, never ending in a hyphen. */
export function suggestCourseSlug(title: string): string {
  return slugifyTitle(title).slice(0, COURSE_SLUG_MAX).replace(/-+$/, "");
}

/** Validates trimmed values, as the form submits them. Empty object means valid. */
export function validateCreateCourseForm(input: {
  title: string;
  slug: string;
}): CreateCourseFormErrors {
  const errors: CreateCourseFormErrors = {};
  const title = input.title.trim();
  const slug = input.slug.trim();

  if (title.length === 0) errors.title = "required";
  else if (title.length > COURSE_TITLE_MAX) errors.title = "tooLong";

  if (slug.length < COURSE_SLUG_MIN) errors.slug = "tooShort";
  else if (slug.length > COURSE_SLUG_MAX) errors.slug = "tooLong";
  else if (!COURSE_SLUG_PATTERN.test(slug)) errors.slug = "invalid";

  return errors;
}
